export default __webpack_public_path__ + "060572afd296f0dddd5d78116f7b62ab.png";